module.exports = __webpack_public_path__ + "static/media/sarajeva2.3e24afa6.jpg";